import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import moment from "moment";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import BindingBox from "./BindingBox";
import BindingFailBox from "./BindingFailBox";
import ReviewBox from "./ReviewBox";
import { getMemberActionIsRead } from "../../actions/memberActions";
import { getGames, getServers } from "../../actions/gameActions";
import { getBindings, getBindingsFail, getReviews, getDispute, applyBinding, cancelBinding, getRetrieveLast } from "../../actions/bindActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from '../../validation/is-empty';
import './bind.css';

class BindPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      game_id: "",
      server_id: "",
      role_id: "",
      role_name: "",
      agree: false,
      attachments: [],
      servers: [],
      showModal: "",
      selRoleId: "",
      showModalFailMessage: "",
      showModalDisputeMessage: "",
      showModalRetrieveMessage: "",
      retrieveMessage: "",
      showModalBackdrop: "",
      error: {}
    };

    this.handleShowModalFailMessage = this.handleShowModalFailMessage.bind(this);
    this.handleCloseModalFailMessage = this.handleCloseModalFailMessage.bind(this);
    this.handleShowModalDisputeMessage = this.handleShowModalDisputeMessage.bind(this);
    this.handleCloseModalDisputeMessage = this.handleCloseModalDisputeMessage.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.cancelClick = this.cancelClick.bind(this);
    this.retrieveAccount = this.retrieveAccount.bind(this);
    this.handleCloseModalRetrieveMessage = this.handleCloseModalRetrieveMessage.bind(this);
  }
  
  componentDidMount = () => {
    this.props.getMemberActionIsRead();
    this.props.getGames();
    this.props.getBindings();
    this.props.getBindingsFail();
    this.props.getReviews();
    this.props.getDispute();
  };

  componentDidUpdate(prevProps) {

    if (this.props.game !== prevProps.game) {
      this.setState({ servers: this.props.game.servers });
    }
    
    if (this.props.errors !== prevProps.errors) {
      this.setState({ error: this.props.errors });
    }

    if (this.props.applyResult !== prevProps.applyResult) {
      if(this.props.applyResult.msg && this.props.applyResult.msg === "Apply Binding OK") {
        this.setState({ showModal: "", showModalBackdrop: "" });
        this.setState({ game_id: "", server_id: "", role_id: "", agree: false, attachments: [], error: {} });
        this.props.getBindingsFail();
        this.props.getReviews();
      }
    }

    if (this.props.cancelResult !== prevProps.cancelResult) {
      if(this.props.cancelResult.msg && this.props.cancelResult.msg === "Cancel Binding OK") {
        this.props.getBindingsFail();
        this.props.getReviews();
      }
    }

    if (this.props.retrieveLast !== prevProps.retrieveLast) {
      if (this.props.retrieveLast) {
        if (this.props.retrieveLast.dispute === 1) {
          let retrieveMessage = "您的帳號已被系統鎖定為爭議帳號，暫時無法使用帳號找回服務，請您使用線上客服中心與客服人員聯繫，謝謝。";
          this.setState({ showModalRetrieveMessage: "show", showModalBackdrop: "modal-backdrop show", retrieveMessage: retrieveMessage });
        } else if (this.props.retrieveLast.retrieve_result === 1 && moment().diff(moment(this.props.retrieveLast.update_time), 'days') < 30) {
          let retrieveDays = 30 - moment().diff(moment(this.props.retrieveLast.update_time), 'days');
          this.setState({ showModalRetrieveMessage: "show", showModalBackdrop: "modal-backdrop show", retrieveMessage: `${retrieveDays} 天後可再進行申請` });
        } else {
          this.props.history.push(`/members/retrieve_account/${this.state.selRoleId}`);
        }
      } else {
        this.props.history.push(`/members/retrieve_account/${this.state.selRoleId}`);
      }
    }
  };

  handleShowModalFailMessage(selRoleId) {
    this.setState({ selRoleId: selRoleId, showModalFailMessage: "show", showModalBackdrop: "modal-backdrop show" });
  }

  handleCloseModalFailMessage() {
    this.setState({ showModalFailMessage: "", showModalBackdrop: "" });
  }

  handleShowModalDisputeMessage() {
    this.setState({ showModalDisputeMessage: "show", showModalBackdrop: "modal-backdrop show" });
  }

  handleCloseModalDisputeMessage() {
    this.setState({ showModalDisputeMessage: "", showModalBackdrop: "" });
  }

  handleShowModal() {
    this.setState({ showModal: "show", showModalBackdrop: "modal-backdrop show" });
  }

  handleCloseModal() {
    this.setState({ showModal: "", showModalBackdrop: "" });
    this.setState({ game_id: "", server_id: "", role_id: "", agree: false, attachments: [], error: {} });
  }

  onClick(e) {
    e.preventDefault();
    const { game_id, server_id, role_id, role_name, agree, attachments } = this.state;

    let error = {};

    if (isEmpty(game_id)) {
      error.game_id= "請選擇遊戲";
    }

    if (isEmpty(server_id)) {
      error.server_id= "請選擇伺服器";
    }

    if (isEmpty(role_id)) {
      error.role_id= "請輸入角色ID";
    }

    if (isEmpty(role_name)) {
      error.role_name= "請輸入角色暱稱";
    }

    if (attachments.length === 0) {
      error.file= "請上傳檔案";
    }

    if (!agree) {
      error.agree= "請勾選同意";
    }

    if (!isEmpty(error)){
      this.setState({ error: error });
    } else {
      this.setState({ error: {} });

      let formData = new FormData();

      for (let index = 1; index <= attachments.length; index++) {
        formData.append(`attachment${index}`, attachments[index - 1]);
      }

      formData.append("game_id", game_id);
      formData.append("server_id", server_id);
      formData.append("role_id", role_id);
      formData.append("role_name", role_name);

      this.props.applyBinding(formData);
    }
  }

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    if (e.target.name === "game_id") {
      this.setState({ [e.target.name]: e.target.value });
      this.props.getServers(e.target.value);
    }else if (e.target.name === "agree") {
      if (e.target.checked) {
        this.setState({ agree: true });
      } else {
        this.setState({ agree: false });
      }
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }

    if (!isEmpty(e.target.files)) {
      if (Object.keys(e.target.files).length > 3) {
        this.setState({
          error: { file: "請勿選取超過3個檔案" },
          attachments: [],
        });
      } else {
        this.setState({ error: {}, attachments: e.target.files });
      }
    }
  }
  
  cancelClick(selReviewId) {
    let formData = new FormData();

    formData.append("review_id", selReviewId);
    this.props.cancelBinding(formData);
  }

  retrieveAccount(selRoleId) {
    this.setState({ selRoleId: selRoleId });
    this.props.getRetrieveLast(selRoleId);
  }

  handleCloseModalRetrieveMessage() {
    this.setState({ showModalRetrieveMessage: "", showModalBackdrop: "", retrieveMessage: "" });
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (!isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { isRead, games, bindings, bindingsFail, reviews, dispute } = this.props;
    const { game_id, server_id, role_id, role_name, agree, attachments, servers, showModal, selRoleId, showModalFailMessage, showModalDisputeMessage, showModalRetrieveMessage, retrieveMessage, showModalBackdrop, error } = this.state;

    let bindingBox;
    if (bindings.length === 0) {
      bindingBox = null;
    } else {
      bindingBox = bindings
        .map((binding, idx) => <BindingBox key={`binding-${idx}`} binding={binding} retrieveAccount={this.retrieveAccount} />);
    }

    let bindingsFailBox;
    if (bindingsFail.length === 0) {
      bindingsFailBox = null;
    } else {
      bindingsFailBox = bindingsFail
        .map((binding, idx) => <BindingFailBox key={`bindingfail-${idx}`} binding={binding} selRoleId={selRoleId} showModalFailMessage={showModalFailMessage} 
        handleShowModalFailMessage={this.handleShowModalFailMessage} handleCloseModalFailMessage={this.handleCloseModalFailMessage} />);
    }

    let reviewsBox;
    if (reviews.length === 0) {
      reviewsBox = null;
    } else {
      reviewsBox = reviews
        .map((review, idx) => <ReviewBox key={`review-${idx}`} review={review} cancelClick={this.cancelClick} />);
    }

    let fileInfo;
    if (attachments.length === 0) {
      fileInfo = null;
    } else {
      fileInfo = Object.keys(attachments)
      .map(function(attach){
        let tmpStr = attachments[attach].name.substring(0, attachments[attach].name.lastIndexOf('.'));
        if (tmpStr.length > 10) {
          tmpStr = tmpStr.substring(0, 10) + "..";
        }
        tmpStr = tmpStr + attachments[attach].name.substring(attachments[attach].name.lastIndexOf('.'))
        return (<li>{tmpStr}</li>)
      });
    }

    let formGroup = {
      marginBottom: "20px", 
      justifyContent: "center", 
      display: "inline-flex"
    };

    let formLabel = {
      color: "#949494", 
      margin: "auto", 
      textAlign: "left", 
      width: "80px"
    };

    let formControl = {
      width: "220px", 
      height: "40px", 
      border: "1.5px solid #C7C7C7"
    };

    let formControlFile = {
      width: "220px", 
      height: "40px"
    };
    
    let errorSpan = {
      textAlign: "left", 
      margin: "-25px 0 0 80px"
    };

    let modalDialog = {
      width: "400px",
      margin: "200px auto",
    };
    
    let modalBody = {
        padding: "0px 49px",
    };

    let modalFooter = {
        textAlign: "center",
        border: "0",
        margin: "-20px 0 15px",
    };

    let modalFooterButtonCancel = {
      backgroundColor: "#676767",
      padding: "10px 50px",
      borderRadius: "30px",
      margin: "0 5px 0 0",
    };

    let modalFooterButton = {
      padding: "10px 50px",
      borderRadius: "30px",
      margin: "0",
    };

    let modalContent = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      pointerEvents: "auto",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid rgba(0, 0, 0, .2)",
      borderRadius: "20px",
    };

    let modalHeader = {
      flexDhrink: "0",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "3rem 2rem",
      borderBottom: "0",
      textAlign: "center",
      borderTopLeftRadius: "calc(0.3rem - 1px)",
      borderTopRightRadius: "calc(0.3rem - 1px)",
  }

    let modalTitle = {
      marginBottom: "0",
      lineHeight: "1.5",
      fontSize: "2.5rem",
      fontWeight: "600",
      color: "#191A1C",
    }

    if (window.innerWidth <= 480) {
      modalBody.padding = "0px 25px";
      modalDialog.maxWidth = "330px";
      modalDialog.margin = "20px auto";
      modalTitle.fontSize = "2rem";
      formLabel.width = "70px";
      formControl.width = "200px";
      formControlFile.width = "200px";
      errorSpan.margin = "-25px 0 0 100px";
    }

    let t2 = {
      color: "#F6490D", 
      fontWeight: "600", 
      fontSize: "16px", 
      textAlign: "center"
    };

    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(isAuthTokenValid) && (
        <div id="page">
          <Navbar isRead={isRead} />
          <aside className="colorlib-breadcrumbs">
            <div className="container">
            <div className="row">
              <div className="col-md-12 breadcrumbs text-center">
              <h2>遊戲綁定</h2>
              <p><span>games binding</span></p>
              </div>
            </div>
            </div>
          </aside>
          <div className="colorlib">
            <div className="container">
              <button type="button" className="btn btn-danger btn-block bind" onClick={dispute.dispute === 1 ? this.handleShowModalDisputeMessage : this.handleShowModal}>綁定 </button>
                <div className="row">
                  {bindingBox}
                  {reviewsBox}
                  {bindingsFailBox}
                </div>
              </div>
            </div>

            {/*<div className="container mt-3">
              <div className={`modal ${showModal}`}  id="myModal" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={modalDialog}>
                  <div className="modal-content" style={modalContent}> 
                    <div className="modal-header" style={modalHeader}>
                      <h4 className="modal-title" id="myModalLabel" style={modalTitle}>選擇要安全綁定的遊戲</h4>
                    </div>
                    <div className="modal-body"> 
                      <form>

                        <div className="form-group" style={formGroup}>
                          <label style={formLabel}>綁定遊戲</label>
                          <select id="game_id" name="game_id" type="text" className="form-control pretty-select" style={formControl} value={game_id} onChange={this.onChange}>
                            <option value="">請選擇遊戲</option>
                            {games.filter(game => game.vip_wire_report_tw>0 && game.game_id==="h55naxx2tw")
                            .map(game => <option value={game.game_id}>{game.name}</option>)
                            }
                          </select>
                        </div>
                        {error.game_id && (
                          <span style={errorSpan}><img src="img/icon_wrong.svg" alt="" />{error.game_id}</span> )} 

                        <div className="form-group" style={formGroup}>
                          <label style={formLabel}>伺服器</label>
                          <select id="server_id" name="server_id" type="text" className="form-control pretty-select" style={formControl} value={server_id} onChange={this.onChange}>
                            <option value="">請選擇伺服器</option>
                            {servers.map(server => <option value={server.server_id}>{server.server_name}</option>)}
                          </select>
                        </div>
                        {error.server_id && (
                          <span style={errorSpan}><img src="img/icon_wrong.svg" alt="" />{error.server_id}</span> )} 

                        <div className="form-group" style={formGroup}>
                          <label style={formLabel}>角色ID</label>
                          <input id="role_id" name="role_id" type="text" className="form-control" style={formControl} value={role_id} onChange={this.onChange} />
                        </div>
                        {error.role_id && (
                          <span style={errorSpan}><img src="img/icon_wrong.svg" alt="" />{error.role_id}</span> )} 

                        <div className="form-group" style={formGroup}>
                          <label style={formLabel}>角色暱稱</label>
                          <input id="role_name" name="role_name" type="text" className="form-control" style={formControl} value={role_name} onChange={this.onChange} />
                        </div>
                        {error.role_name && (
                          <span style={errorSpan}><img src="img/icon_wrong.svg" alt="" />{error.role_name}</span> )}

                        <div className="form-group" style={formGroup}>
                          <label style={formLabel}>訂單資料</label>
                          <input className="form-control-static" type="file" id="file" name="file" style={formControlFile} accept="image/gif,image/jpeg,image/png" multiple onChange={this.onChange} />
                        </div>
                        <span style={errorSpan}>{fileInfo}</span>
                        {error.file && (
                          <span style={errorSpan}><img src="img/icon_wrong.svg" alt="" />{error.file}</span> )} 
                        <p className="t1" style={{color: "#000", fontWeight: "600", textAlign: "left"}}>* 請提供最近期三筆雙平台儲值訂單。<a href="/help/home" target="_blank" rel="noopener noreferrer">點我看範例</a></p>
                        <p className="t1" style={{color: "#F6490D", fontWeight: "600", textAlign: "left"}}>綁定規範<br />1. 一旦綁定不能進行解綁、轉移<br />2. 綁定成功對應帳號底下其他角色會被一同綁定<br />3. 每個會員帳號，一款遊戲僅能綁定三隻不同帳號的角色</p>
                    
                      </form>

                    </div>
                    <div className="form-check" style={{margin: "0 20px 18px"}}>
                      <input className="form-check-input" type="checkbox" id="agree" name="agree" style={{marginLeft: "3rem"}} checked={agree} onChange={this.onChange} />
                      <label className="form-check-label" htmlFor="agree" style={{color: "#000"}}>
                        我已確認並同意上方綁定規範
                      </label>
                    </div>
                    {error.agree && (
                      <span style={errorSpan}><img src="img/icon_wrong.svg" alt="" />{error.agree}</span> )} 
                    <div className="modal-footer" style={modalFooter}>
                      <button type="button" className="btn btn-danger" data-bs-dismiss="modal" style={modalFooterButtonCancel} onClick={this.handleCloseModal}>取消</button>
                      <button type="button" className="btn btn-danger" data-bs-dismiss="modal" style={modalFooterButton} onClick={this.onClick}>綁定</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}

            <div className="container mt-3">
              <div className={`modal ${showModal}`}  id="myModal" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={modalDialog}>
                  <div className="modal-content" style={modalContent}> 
                    <div className="modal-header" style={modalHeader}>
                    </div>
                    <div className="modal-body" style={modalBody}> 
                      <p className="t2" style={t2}>為強化提供更安全的使用環境與驗證機制，即日起將暫時關閉會員綁定服務進行系統優化，開放時間將另行公告。</p><br />
                    </div>
                    <div className="modal-footer" style={modalFooter}>
                        <button type="button" className="btn btn-danger" style={modalFooterButton} onClick={this.handleCloseModal}>關閉</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container mt-3">
              <div className={`modal ${showModalDisputeMessage}`} id="myModa2" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={modalDialog}>
                  <div className="modal-content" style={modalContent}> 
                    <div className="modal-header" style={modalHeader}>
                    </div>
                    <div className="modal-body" style={modalBody}> 
                      {/*<p className="t2" style={t2}>您的帳號已被系統鎖定為爭議帳號，暫時無法使用帳號綁定服務，請您使用線上客服中心與客服人員聯繫，謝謝。</p><br />*/}
                      <p className="t2" style={t2}>為強化提供更安全的使用環境與驗證機制，即日起將暫時關閉會員綁定服務進行系統優化，開放時間將另行公告。</p><br />
                    </div>
                    <div className="modal-footer" style={modalFooter}>
                        <button type="button" className="btn btn-danger" style={modalFooterButton} onClick={this.handleCloseModalDisputeMessage}>關閉</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container mt-3">
              <div className={`modal ${showModalRetrieveMessage}`} id="myModa2" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={modalDialog}>
                  <div className="modal-content" style={modalContent}> 
                    <div className="modal-header" style={modalHeader}>
                    </div>
                    <div className="modal-body" style={modalBody}> 
                      <p className="t2" style={t2}>{retrieveMessage}</p><br />
                    </div>
                    <div className="modal-footer" style={modalFooter}>
                        <button type="button" className="btn btn-danger" style={modalFooterButton} onClick={this.handleCloseModalRetrieveMessage}>關閉</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer showAgreement={true} />
          <div className={showModalBackdrop}></div>
        </div>
        )}
      </Fragment>
    );
  }
}

BindPage.propTypes = {
  getMemberActionIsRead: PropTypes.func.isRequired,
  getGames: PropTypes.func.isRequired,
  getServers: PropTypes.func.isRequired,
  getBindings: PropTypes.func.isRequired,
  getBindingsFail: PropTypes.func.isRequired,
  getReviews: PropTypes.func.isRequired,
  getDispute: PropTypes.func.isRequired,
  applyBinding: PropTypes.func.isRequired,
  cancelBinding: PropTypes.func.isRequired,
  getRetrieveLast: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  errors: state.errors,
  games: state.games.games,
  game: state.games.game,
  bindings: state.bind.bindings,
  bindingsFail: state.bind.bindingsFail,
  reviews: state.bind.reviews,
  dispute: state.bind.dispute,
  applyResult: state.bind.applyBindingResult,
  cancelResult: state.bind.cancelBindingResult,
  retrieveLast: state.bind.retrieveLast,
});

export default connect(mapStateToProps, { getGames, getServers, getBindings, getBindingsFail, getReviews, getDispute, applyBinding, cancelBinding, getRetrieveLast, getMemberActionIsRead })(BindPage);